
import React from 'react';

import Grid from '@mui/material/Grid';

import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import Typography from '@mui/material/Typography';


function Parteciperai(props) {
	const [isComing, setComing] = React.useState(
    props.isComing !== undefined ? props.isComing : "yes"
  );

	const handleClick = (e, v) => {
		if(v === null || v === undefined) {
			return;
		}
    setComing(v);
		if(props.onChange){
			props.onChange(v);
		}
  };

	return (
		<Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }} alignItems="center" >
			<Grid item xs={4} md={6}>
				<Typography variant='subtitle1' sx={{ textAlign: "center", fontFamily: '"Penna"', fontSize: "1.8rem", fontWeight: "bold" }}>
					Parteciperai
				</Typography>
			</Grid>
			<input hidden name='parteciperai' readOnly value={isComing} />
			<Grid item xs={8} md={6}>
				<ToggleButtonGroup
					value={ isComing }
					exclusive
					defaultValue={"no"}
					onChange={handleClick}
					sx={{ m: 2, }}
				>
					<ToggleButton value="yes" aria-label="left aligned">
						<Typography variant='caption' display="block" sx={{ textTransform: "none", fontFamily: '"Penna"', fontSize: "1.2rem", fontWeight: "bold", color: "#fff" }}>
							Ci saro'
						</Typography>
					</ToggleButton>
					<ToggleButton value="no" aria-label="centered">
						<Typography variant='caption' display="block" sx={{ textTransform: "none", fontFamily: '"Penna"', fontSize: "1.2rem", fontWeight: "bold", color: "#fff" }}>
							Mi spiace non posso
						</Typography>
					</ToggleButton>
				</ToggleButtonGroup>
			</Grid>
		</Grid>
	)
}

export default Parteciperai;